
/**
 * sessionStorage
 */
let _session = {
  get: function (key) {
    let item = sessionStorage[key];
    if (!item || item === "null") {
      return null;
    }
    try {
        item = JSON.parse(item);
    } catch (error) {
        // eslint-disable-next-line no-self-assign
        item = item;
    }
    // 如果有startTime的值，说明设置了失效时间
    if (item && item.startTime) {
        let date = new Date().getTime();
        // 如果有过期时间则判断过期时间
        if (item.expires && date >= item.expires) {
            sessionStorage.removeItem(key);
            return null;
        } else {
            return item.value;
        }
    } else {
        return item;
    }
  },
  set: function (key, value, expires) {
    if ((typeof +expires) === 'number') {
        // 记录何时将值存入缓存，毫秒级
        var data = Object.assign({ value, expires: +expires }, { startTime: new Date().getTime() });
        sessionStorage.setItem(key, JSON.stringify(data));
    } else {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        sessionStorage.setItem(key, value);
    }
  },
  // 删除
  remove(key) {
    sessionStorage.removeItem(key);
  },
  // 清除全部
  clear() {
    sessionStorage.clear();
  }
}
window._session = _session;

export { _session }